import type { JSXChild } from 'engine/index';

type FormGroupProps = {
	title?: string;
};
export function FormGroup({ title }: FormGroupProps, children: JSXChild[]) {
	return (
		<div class="flex-1 shrink">
			{title && <h3 class="mb-1 text-lg font-bold text-gray-800 dark:text-gray-200">{title}</h3>}
			<div class="flex flex-col gap-4">{children}</div>
		</div>
	);
}
